import React from "react";

import * as styles from "../styles/components/container.module.css";

const Container = ({
  children,
  footerContainer = false,
  landingPageContainer = false,
  megaMenuContainer = false,
  announcementContainer = false,
}) => {
  return (
    <div
      className={
        footerContainer
          ? styles.rootFooter
          : landingPageContainer
          ? styles.landingPageContainer
          : megaMenuContainer
          ? styles.megaMenuContainer
          : announcementContainer
          ? styles.announcementContainer
          : styles.root
      }
    >
      {children}
    </div>
  );
};

export default Container;
